import { useTranslation } from 'react-i18next';

export const ActiveLibraryTrainingFilter = ({ value }: { value: unknown }) => {
  const { t } = useTranslation();

  if (value) {
    return <>{t('statuses.forTraining')}</>;
  }
  return <></>;
};
